import { Component, Input } from '@angular/core'
import { SocialsecurityService } from '../../services/socialsecurity/socialsecurity.service'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { Filter, QueryGet } from '../../shared/query-types'
import { ActivatedRoute, Router } from '@angular/router'
import { LayoutService } from '../../services/layout/layout.service'
import { SocialSecurity } from '../../models/socialsecurity.interface'
import { PAGINATION } from '../../shared/constants'
import { AsyncPipe, CommonModule } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { Pagination } from '../../models/pagination.interface'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { SocialsecurityFormComponent } from '../socialsecurity-form/socialsecurity-form.component'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-socialsecurity-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        OnlysuperuserDirective,
    ],
    templateUrl: './socialsecurity-list.component.html',
    styleUrl: './socialsecurity-list.component.css',
})
export class SocialsecurityListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    socialSecurityList: SocialSecurity[] = []
    selectedSocialSecurity: SocialSecurity | null = null
    asyncSocialSecurity!: Observable<Pagination<SocialSecurity[]>>
    showColumns: string[] = [
        'acciones',
        'personalData',
        'eps',
        'hasInsurance',
        'insuranceKind',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private socialsecurityService: SocialsecurityService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private loadingService: LoadingService,
        private title: Title
    ) {this.title.setTitle('Seguridad social')}

    fetchSocialSecurity(
        page: number,
        filter: Filter | null = null,
        search = ''
    ) {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncSocialSecurity = this.socialsecurityService
            .allSocialSecurities(params)
            .pipe(
                tap((response) => {
                    this.socialSecurityList = response.results
                    this.socialsecurityService.setSocialSecurities(
                        response.results
                    )
                    this.total = response.count
                }),
                map((res) => {
                    this.loadingService.show(false)
                    return res
                }),
                catchError((error) => {
                    this.loadingService.show(false)
                    this.router.navigate(['home/'])
                    return []
                })
            )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchSocialSecurity(
                        PAGINATION.first_page,
                        null,
                        search
                    )
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(socialSecurity: SocialSecurity): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar el registro: ${socialSecurity}`
        )
        if (!confirmed) return
        this.socialsecurityService
            .deleteSocialSecurity(socialSecurity.id)
            .subscribe({
                next: () => {
                    const successMsg = `Eliminado CORRECTAMENTE!`
                    this.toastr.success(successMsg, 'Exitoso!', {
                        progressBar: true,
                        timeOut: 5000,
                    })
                    this.fetchSocialSecurity(PAGINATION.first_page)
                },
                error: (err) => {
                    this.toastr.error('No se pudo eliminar', 'Error')
                },
            })
    }

    updateEducation(education: SocialSecurity) {
        this.socialsecurityService.setSocialSecurity(education)
        const dialogRef = this.dialog.open(SocialsecurityFormComponent, {
            data: { selectedSocialSecurity: this.selectedSocialSecurity },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchSocialSecurity(PAGINATION.first_page)
        })
    }
    create(): void {}
}
